"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _excluded = ["children"],
  _excluded2 = ["children"],
  _excluded3 = ["children"],
  _excluded4 = ["children"],
  _excluded5 = ["children"],
  _excluded6 = ["children"],
  _excluded7 = ["children"],
  _excluded8 = ["children", "color"],
  _excluded9 = ["children"],
  _excluded10 = ["children"],
  _excluded11 = ["children"],
  _excluded12 = ["children"],
  _excluded13 = ["children"],
  _excluded14 = ["children"],
  _excluded15 = ["children"],
  _excluded16 = ["children"],
  _excluded17 = ["children", "variant"];
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var DisplayXLHeader = function DisplayXLHeader(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_material.Typography, _extends({
    variant: "h1"
  }, props, {
    component: "h2"
  }), children);
};
var DisplayLHeader = function DisplayLHeader(_ref2) {
  var children = _ref2.children,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_react["default"].createElement(_material.Typography, _extends({
    variant: "h2"
  }, props, {
    component: "h3"
  }), children);
};
var DisplayLHeaderRegular = function DisplayLHeaderRegular(_ref3) {
  var children = _ref3.children,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_react["default"].createElement(_material.Typography, _extends({
    variant: "h2",
    component: "h3"
  }, props, {
    style: _objectSpread({
      fontWeight: 400
    }, props.style)
  }), children);
};
var Heading1 = function Heading1(_ref4) {
  var children = _ref4.children,
    props = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_react["default"].createElement(_material.Typography, _extends({
    variant: "h3",
    component: "h4"
  }, props), children);
};
var Heading1Regular = function Heading1Regular(_ref5) {
  var children = _ref5.children,
    props = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_react["default"].createElement(_material.Typography, _extends({
    variant: "h3"
  }, props, {
    component: "h4",
    style: _objectSpread({
      fontWeight: 400
    }, props.style)
  }), children);
};
var Heading2 = function Heading2(_ref6) {
  var children = _ref6.children,
    props = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/_react["default"].createElement(_material.Typography, _extends({
    variant: "h4"
  }, props, {
    component: "h5"
  }), children);
};
var Heading2Regular = function Heading2Regular(_ref7) {
  var children = _ref7.children,
    props = _objectWithoutProperties(_ref7, _excluded7);
  return /*#__PURE__*/_react["default"].createElement(_material.Typography, _extends({
    variant: "h4"
  }, props, {
    component: "h5",
    style: _objectSpread({
      fontWeight: 400
    }, props.style)
  }), children);
};
var PageHeadingSubtitle = function PageHeadingSubtitle(_ref8) {
  var children = _ref8.children,
    color = _ref8.color,
    props = _objectWithoutProperties(_ref8, _excluded8);
  return /*#__PURE__*/_react["default"].createElement(_material.Typography, _extends({
    variant: "body2",
    component: "h6",
    style: _objectSpread({
      fontWeight: 400
    }, props.style)
  }, props), children);
};
var Body1 = function Body1(_ref9) {
  var children = _ref9.children,
    props = _objectWithoutProperties(_ref9, _excluded9);
  return /*#__PURE__*/_react["default"].createElement(_material.Typography, _extends({
    variant: "body1"
  }, props), children);
};
var Body2 = function Body2(_ref10) {
  var children = _ref10.children,
    props = _objectWithoutProperties(_ref10, _excluded10);
  return /*#__PURE__*/_react["default"].createElement(_material.Typography, _extends({
    variant: "body2"
  }, props), children);
};
var Subtitle1 = function Subtitle1(_ref11) {
  var children = _ref11.children,
    props = _objectWithoutProperties(_ref11, _excluded11);
  return /*#__PURE__*/_react["default"].createElement(_material.Typography, _extends({
    variant: "subtitle1",
    color: "textSecondary"
  }, props), children);
};
var Subtitle2 = function Subtitle2(_ref12) {
  var children = _ref12.children,
    props = _objectWithoutProperties(_ref12, _excluded12);
  return /*#__PURE__*/_react["default"].createElement(_material.Typography, _extends({
    variant: "subtitle2",
    color: "textSecondary"
  }, props), children);
};
var InfoText = function InfoText(_ref13) {
  var children = _ref13.children,
    props = _objectWithoutProperties(_ref13, _excluded13);
  return /*#__PURE__*/_react["default"].createElement(_material.Typography, _extends({
    variant: "subtitle2",
    color: "textSecondary"
  }, props, {
    style: _objectSpread({}, props.style)
  }), children);
};
var Caption = function Caption(_ref14) {
  var children = _ref14.children,
    props = _objectWithoutProperties(_ref14, _excluded14);
  return /*#__PURE__*/_react["default"].createElement(_material.Typography, _extends({
    variant: "caption"
  }, props), children);
};
var Placeholder = function Placeholder(_ref15) {
  var children = _ref15.children,
    props = _objectWithoutProperties(_ref15, _excluded15);
  return /*#__PURE__*/_react["default"].createElement(_material.Typography, _extends({
    variant: "caption"
  }, props, {
    style: _objectSpread({
      fontStyle: 'italic',
      fontSize: '0.714rem'
    }, props.style)
  }), children);
};
var MachineText = function MachineText(_ref16) {
  var children = _ref16.children,
    props = _objectWithoutProperties(_ref16, _excluded16);
  return /*#__PURE__*/_react["default"].createElement(_material.Typography, _extends({
    variant: "button"
  }, props, {
    style: _objectSpread({
      fontSize: '0.857rem'
    }, props.style)
  }), children);
};
var SensorCardValue = function SensorCardValue(_ref17) {
  var children = _ref17.children,
    variant = _ref17.variant,
    props = _objectWithoutProperties(_ref17, _excluded17);
  return /*#__PURE__*/_react["default"].createElement(_material.Typography, _extends({
    variant: variant || 'h3',
    component: "div"
  }, props), children);
};
DisplayXLHeader.propTypes = {
  children: _propTypes["default"].node.isRequired
};
DisplayLHeader.propTypes = {
  children: _propTypes["default"].node.isRequired
};
DisplayLHeaderRegular.propTypes = {
  children: _propTypes["default"].node.isRequired
};
Heading1.propTypes = {
  children: _propTypes["default"].node.isRequired
};
Heading1Regular.propTypes = {
  children: _propTypes["default"].node.isRequired
};
Heading2.propTypes = {
  children: _propTypes["default"].node.isRequired
};
Heading2Regular.propTypes = {
  children: _propTypes["default"].node.isRequired
};
PageHeadingSubtitle.propTypes = {
  children: _propTypes["default"].node.isRequired
};
Body1.propTypes = {
  children: _propTypes["default"].node.isRequired
};
Body2.propTypes = {
  children: _propTypes["default"].node.isRequired
};
Subtitle1.propTypes = {
  children: _propTypes["default"].node.isRequired
};
Subtitle2.propTypes = {
  children: _propTypes["default"].node.isRequired
};
InfoText.propTypes = {
  children: _propTypes["default"].node.isRequired
};
Caption.propTypes = {
  children: _propTypes["default"].node.isRequired
};
Placeholder.propTypes = {
  children: _propTypes["default"].node.isRequired
};
MachineText.propTypes = {
  children: _propTypes["default"].node.isRequired
};
SensorCardValue.propTypes = {
  children: _propTypes["default"].node.isRequired
};
var NotifyTypo = {
  DisplayXLHeader: DisplayXLHeader,
  DisplayLHeader: DisplayLHeader,
  DisplayLHeaderRegular: DisplayLHeaderRegular,
  Heading1: Heading1,
  Heading1Regular: Heading1Regular,
  Heading2: Heading2,
  Heading2Regular: Heading2Regular,
  PageHeadingSubtitle: PageHeadingSubtitle,
  Body1: Body1,
  Body2: Body2,
  Subtitle1: Subtitle1,
  Subtitle2: Subtitle2,
  InfoText: InfoText,
  Caption: Caption,
  Placeholder: Placeholder,
  MachineText: MachineText,
  SensorCardValue: SensorCardValue
};
var _default = exports["default"] = NotifyTypo;